import { render, staticRenderFns } from "./settings.vue?vue&type=template&id=5a4c58ad&scoped=true"
import script from "./settings.vue?vue&type=script&lang=js"
export * from "./settings.vue?vue&type=script&lang=js"
import style0 from "./settings.vue?vue&type=style&index=0&id=5a4c58ad&prod&lang=css"
import style1 from "./settings.vue?vue&type=style&index=1&id=5a4c58ad&prod&lang=css"
import style2 from "./settings.vue?vue&type=style&index=2&id=5a4c58ad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4c58ad",
  null
  
)

export default component.exports